module.exports = __webpack_public_path__ + "static/media/phone.d408437.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Clocks/phone.mp4
// module id = Bgpc
// module chunks = 1